import 'babel-polyfill';
import $ from 'jquery'; //eslint-disable-line no-unused-vars
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import routes from './routes';
import store from './store';
import history from './providers/HistoryProvider';
import {getInitialData} from './actions/InitialData';
import {GetComplaintPositionComponents} from './actions/Components';

store.dispatch(getInitialData());
store.dispatch(GetComplaintPositionComponents());

ReactDOM.render(
    <Provider store={store}>
        <Router history={history}>
            {routes}
        </Router>
    </Provider>
    ,document.getElementById('app'));


// WEBPACK FOOTER //
// ./src/index.js